<h1 class="page-title">Groups</h1>
<button class="btn" (click)="this.groupsService.openCreateOrEditGroupDialog()">
  <app-icon name="plus"></app-icon>
  Create new group
</button>
<app-card title="All Groups">
  @if (dataSource.data.length > 0) {
    <div
      class="table-container"
      >
      <table
        mat-table
        multiTemplateDataRows
        [dataSource]="dataSource"
        class="admin-table"
        >
        <ng-container matColumnDef="groupName">
          <mat-header-cell *matHeaderCellDef>Group Name</mat-header-cell>
          <mat-cell *matCellDef="let group">
            <span
              class="group-name-link"
              (click)="openGroupDetailView(group)"
              style="cursor: pointer; color: #1976d2; text-decoration: underline"
              >
              {{ group.groupName }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="trackingPeriod">
          <mat-header-cell *matHeaderCellDef
            >Timeperiod of Tracking</mat-header-cell
            >
            <mat-cell *matCellDef="let group">
              {{ group.trackingPeriodStart | date : "d.MM.yyyy" }} -
              {{ group.trackingPeriodFinish | date : "d.MM.yyyy" }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="numberOfStudents">
            <mat-header-cell *matHeaderCellDef>Number of students</mat-header-cell>
            <mat-cell *matCellDef="let group">{{ group.studentCount }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
            <mat-cell *matCellDef="let group">
              <span
                class="progress-chip"
                [ngClass]="groupsService.getGroupTrackingStatus(group)"
                >
                {{ groupsService.getGroupTrackingStatus(group) }}
              </span>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </table>
      </div>
    } @else {
      <p>You are not an admin of any group.</p>
    }
  </app-card>
